// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const relationListQuerySchema = z
  .object({
    id: z.array(idSchema),
    type: z.union([z.literal('export'), z.literal('einvoice')]),
    annotation: z.array(idSchema),
    key: z.string(),
    document: z.array(idSchema),
  })
  .partial()
  .and(paginationQuerySchema);
